import React from 'react';
// import { useState } from "react";

const Tag = props => {
    return(
        <li>{props.tagname}</li>
    ) 
}

 export default Tag;